import { Button } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

export interface IButtonClearFiltersProps {
  onClick: () => void;
}

export function ButtonClearFilters({ onClick }: IButtonClearFiltersProps) {
  const { t } = useTranslation();

  return (
    <Button id="transactions-filters-clear-btn" onClick={onClick} variant="ghost" size="s" className="pl-5">
      {t('pages.currentProfiles.cards.filters.clear')}
    </Button>
  );
}
